import React, { useState } from "react";
import { Switch, Text, TextArea, MultipleUpload, SimpleSelect } from "../../../../../../../../components/fields";
import { Alert, Select, Collapse } from "components";
import GenerateSerials from "../generate-serials";
import MinMax from "../min-max";
import config from "constants/config";
import useMobile from "../../../../../../../../hooks/useMobile";
import { CollapseArrow } from "../../../../../settings/shop/crypto/swaps";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { Select as ReactSelect } from "@paylixecommerce/shared/components";

import "./index.scss";




const StandardIcon1 = () => <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M3.06665 21H21.0667" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M3.06665 10H21.0667" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M5.06665 6L12.0667 3L19.0667 6" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M4.06665 10V21" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M20.0667 10V21" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M8.06665 14V17" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M12.0667 14V17" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M16.0667 14V17" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const StandardIcon2 = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M12 10C12 10.5304 12.2107 11.0391 12.5858 11.4142C12.9609 11.7893 13.4696 12 14 12C14.5304 12 15.0391 11.7893 15.4142 11.4142C15.7893 11.0391 16 10.5304 16 10C16 9.46957 15.7893 8.96086 15.4142 8.58579C15.0391 8.21071 14.5304 8 14 8C13.4696 8 12.9609 8.21071 12.5858 8.58579C12.2107 8.96086 12 9.46957 12 10Z" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M12.5 11.5L8.5 15.5L10 17" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M12 15L10.5 13.5" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const StandardIcon3 = () => <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M12.3328 3C14.6687 5.06658 17.7173 6.14257 20.8328 6C21.2864 7.54302 21.4252 9.16147 21.241 10.7592C21.0567 12.3569 20.5532 13.9013 19.7602 15.3005C18.9673 16.6998 17.9012 17.9254 16.6253 18.9045C15.3494 19.8836 13.8896 20.5962 12.3328 21C10.7761 20.5962 9.31632 19.8836 8.04039 18.9045C6.76445 17.9254 5.69835 16.6998 4.90544 15.3005C4.11252 13.9013 3.60898 12.3569 3.42472 10.7592C3.24046 9.16147 3.37925 7.54302 3.83284 6C6.94837 6.14257 9.99701 5.06658 12.3328 3" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M12.333 12C12.8853 12 13.333 11.5523 13.333 11C13.333 10.4477 12.8853 10 12.333 10C11.7807 10 11.333 10.4477 11.333 11C11.333 11.5523 11.7807 12 12.333 12Z" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M12.333 12V14.5" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;



const FileIcon = ({ className }) => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path d="M11.667 2.5V5.83333C11.667 6.05435 11.7548 6.26631 11.9111 6.42259C12.0674 6.57887 12.2793 6.66667 12.5003 6.66667H15.8337" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M14.167 17.5H5.83366C5.39163 17.5 4.96771 17.3244 4.65515 17.0118C4.34259 16.6993 4.16699 16.2754 4.16699 15.8333V4.16667C4.16699 3.72464 4.34259 3.30072 4.65515 2.98816C4.96771 2.67559 5.39163 2.5 5.83366 2.5H11.667L15.8337 6.66667V15.8333C15.8337 16.2754 15.6581 16.6993 15.3455 17.0118C15.0329 17.3244 14.609 17.5 14.167 17.5Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M7.5 14.1641H12.5" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M7.5 10.8359H12.5" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	)
}


const SerialsIcon = ({ className }) => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path d="M10 8.33073C10 8.77276 10.1756 9.19668 10.4882 9.50924C10.8007 9.8218 11.2246 9.9974 11.6667 9.9974C12.1087 9.9974 12.5326 9.8218 12.8452 9.50924C13.1577 9.19668 13.3333 8.77276 13.3333 8.33073C13.3333 7.8887 13.1577 7.46478 12.8452 7.15222C12.5326 6.83966 12.1087 6.66406 11.6667 6.66406C11.2246 6.66406 10.8007 6.83966 10.4882 7.15222C10.1756 7.46478 10 7.8887 10 8.33073Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M10.4163 9.58594L7.08301 12.9193L8.33301 14.1693" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M10 12.5L8.75 11.25" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	)
}


const ServiceIcon = ({ className }) => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path d="M8.60417 3.5975C8.95917 2.13417 11.0408 2.13417 11.3958 3.5975C11.4491 3.81733 11.5535 4.02148 11.7006 4.19333C11.8477 4.36518 12.0332 4.49988 12.2422 4.58645C12.4512 4.67303 12.6776 4.70904 12.9032 4.69156C13.1287 4.67407 13.3469 4.60359 13.54 4.48583C14.8258 3.7025 16.2983 5.17417 15.515 6.46083C15.3974 6.65388 15.327 6.87195 15.3096 7.09731C15.2922 7.32267 15.3281 7.54897 15.4146 7.75782C15.5011 7.96666 15.6356 8.15215 15.8073 8.29921C15.9789 8.44627 16.1829 8.55075 16.4025 8.60417C17.8658 8.95917 17.8658 11.0408 16.4025 11.3958C16.1827 11.4491 15.9785 11.5535 15.8067 11.7006C15.6348 11.8477 15.5001 12.0332 15.4135 12.2422C15.327 12.4512 15.291 12.6776 15.3084 12.9032C15.3259 13.1287 15.3964 13.3469 15.5142 13.54C16.2975 14.8258 14.8258 16.2983 13.5392 15.515C13.3461 15.3974 13.1281 15.327 12.9027 15.3096C12.6773 15.2922 12.451 15.3281 12.2422 15.4146C12.0333 15.5011 11.8479 15.6356 11.7008 15.8073C11.5537 15.9789 11.4492 16.1829 11.3958 16.4025C11.0408 17.8658 8.95917 17.8658 8.60417 16.4025C8.5509 16.1827 8.44648 15.9785 8.29941 15.8067C8.15233 15.6348 7.96676 15.5001 7.75779 15.4135C7.54882 15.327 7.32236 15.291 7.09685 15.3084C6.87133 15.3259 6.65313 15.3964 6.46 15.5142C5.17417 16.2975 3.70167 14.8258 4.485 13.5392C4.60258 13.3461 4.67296 13.1281 4.6904 12.9027C4.70785 12.6773 4.67187 12.451 4.58539 12.2422C4.49892 12.0333 4.36438 11.8479 4.19273 11.7008C4.02107 11.5537 3.81714 11.4492 3.5975 11.3958C2.13417 11.0408 2.13417 8.95917 3.5975 8.60417C3.81733 8.5509 4.02148 8.44648 4.19333 8.29941C4.36518 8.15233 4.49988 7.96676 4.58645 7.75779C4.67303 7.54882 4.70904 7.32236 4.69156 7.09685C4.67407 6.87133 4.60359 6.65313 4.48583 6.46C3.7025 5.17417 5.17417 3.70167 6.46083 4.485C7.29417 4.99167 8.37417 4.54333 8.60417 3.5975Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	)
}


const DynamicIcon = ({ className }) => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path d="M4.06333 11.3438C3.57186 11.6517 3.16926 12.0826 2.8953 12.5938C2.62134 13.105 2.48551 13.6789 2.50122 14.2587C2.51694 14.8384 2.68367 15.4041 2.98492 15.8997C3.28618 16.3953 3.71154 16.8038 4.21897 17.0846C4.72641 17.3655 5.29835 17.5092 5.87829 17.5014C6.45823 17.4935 7.02609 17.3345 7.52577 17.04C8.02544 16.7456 8.43963 16.3258 8.72741 15.8222C9.01519 15.3187 9.16659 14.7487 9.16667 14.1688H14.1667" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M12.555 17.0824C13.0002 17.3281 13.4958 17.4687 14.0037 17.4935C14.5117 17.5182 15.0185 17.4263 15.4855 17.225C15.9525 17.0236 16.3672 16.7181 16.6979 16.3318C17.0286 15.9455 17.2666 15.4886 17.3935 14.9962C17.5205 14.5037 17.5331 13.9888 17.4303 13.4907C17.3276 12.9927 17.1123 12.5247 16.8009 12.1227C16.4894 11.7207 16.0901 11.3952 15.6336 11.1713C15.177 10.9474 14.6752 10.8309 14.1667 10.8307C13.5783 10.8307 12.98 10.9799 12.5 11.2474L10 6.66406" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M13.333 6.66927C13.333 5.78522 12.9818 4.93737 12.3567 4.31225C11.7316 3.68713 10.8837 3.33594 9.99967 3.33594C9.11562 3.33594 8.26777 3.68713 7.64265 4.31225C7.01753 4.93737 6.66634 5.78522 6.66634 6.66927C6.66634 7.92427 7.30801 9.0176 8.33301 9.58594L5.83301 14.1693" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	)
}


const SubscriptionIcon = ({ className }) => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path d="M18 9.54849C17.7707 7.8987 17.0054 6.37005 15.8218 5.19802C14.6383 4.02599 13.1023 3.2756 11.4503 3.06245C9.79836 2.84929 8.12215 3.18519 6.67988 4.01841C5.23761 4.85163 4.1093 6.13593 3.46875 7.67349M3 4.92349V7.67349H5.75" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M3 11.4219C3.22927 13.0717 3.99462 14.6003 5.17815 15.7723C6.36168 16.9444 7.89773 17.6948 9.54968 17.9079C11.2016 18.1211 12.8779 17.7852 14.3201 16.952C15.7624 16.1187 16.8907 14.8344 17.5312 13.2969M18 16.0469V13.2969H15.25" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M12.3833 8.74806C12.2777 8.56475 12.1241 8.41363 11.9392 8.31088C11.7542 8.20813 11.5448 8.1576 11.3333 8.16472H10.1667C9.85725 8.16472 9.5605 8.28764 9.34171 8.50643C9.12292 8.72522 9 9.02197 9 9.33139C9 9.64081 9.12292 9.93756 9.34171 10.1563C9.5605 10.3751 9.85725 10.4981 10.1667 10.4981H11.3333C11.6428 10.4981 11.9395 10.621 12.1583 10.8398C12.3771 11.0586 12.5 11.3553 12.5 11.6647C12.5 11.9741 12.3771 12.2709 12.1583 12.4897C11.9395 12.7085 11.6428 12.8314 11.3333 12.8314H10.1667C9.9552 12.8385 9.74578 12.788 9.56083 12.6852C9.37587 12.5825 9.22234 12.4314 9.11667 12.2481" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M10.75 12.8333V14M10.75 7V8.16667V7Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	)
}





const icons = {
	FILE: FileIcon,
	SERIALS: SerialsIcon,
	SERVICE: ServiceIcon,
	DYNAMIC: DynamicIcon,
	SUBSCRIPTION: SubscriptionIcon
}
const description = {
	FILE: "Upload a software, video course or anything that can be downloaded",
	SERIALS: "Activation keys, tokens, accounts and any piece of text that can be sold.",
	SERVICE: "Deliver a service message to your customers and get in touch with them after.",
	DYNAMIC: "Handle the product creation on your own server, we'll handle the rest.",
	SUBSCRIPTION: "Provide recurring payments to your customers managed by us."
}


export const SingleValue = (props) => {

	let { children, innerProps } = props;

	return <div {...innerProps} className="payment-link-type-select-value">
		<div>
			{children}
		</div>
	</div>
}

export const Option = (props) => {

	let { innerProps, data } = props;

	const Icon = icons[data.value];

	return <div {...innerProps} className="payment-link-type-select-option">
		<div className="payment-link-type-select-option-container">
			<div className="payment-link-type-select-option-icon">
				<Icon className="active" />
			</div>
			<div className="payment-link-type-select-option-content">
				<span>{data.label}</span>
				<span>{description[data.value]}</span>
			</div>
		</div>
	</div>
};


export default ({ form, setDelimiter, delimiter, removeFile, isVariant }) => {

	const [isHelpOpen, setHelp] = useState(false);
	const isMobile = useMobile();
	const { id } = useParams();
	const { profile } = useSelector(({ auth }) => auth);
	const isBusiness = profile && profile.subscription && (profile.subscription.id === 1 || profile.subscription.id === 5);

	const getDays = () => {
		let interval = form.values.recurring_interval;
		let count = form.values.recurring_interval_count;

		if(interval) {
			return config.RECURRING_INTERVAL.find(({ value }) => interval === value).label.toLowerCase() + (count > 1 ? 's' : '')
		} else {
			return ""
		}
	};

	const isSubscription = form.values.type === "SUBSCRIPTION";
	const licenseEnabled = form.values.licensing_enabled;


	return <div className="product-form-main-back pb-3">

		<div className="mb-3 position-relative">

			{isMobile ?
				<>

					<div className="payment-link-type-select payment-link-setup-block mb-3">
						<div className="paylixecommerce-label">Type</div>

						<ReactSelect
							// menuIsOpen={true}
							placeholder="Select Link type"
							options={(isVariant ? config.TYPE_OPTIONS_VARIANT : config.TYPE_OPTIONS)}
							classNameDropdown="payment-link-type-select-dropdown"
							className={`${form.errors.type && form.touched.type ? 'error' : ''} w-100`}
							isMulti={false}
							note={null}
							name="type"
							id="type"
							closeMenuOnSelect={true}
							isSearchable={false}
							backspaceRemovesValue={true}
							value={
								form.values.type && typeof form.values.type === "string"
									? (isVariant ? config.TYPE_OPTIONS_VARIANT : config.TYPE_OPTIONS).find(({ value }) => form.values.type === value)
									: form.values.type
							}
							onChange={(option) => {
								console.log(option);
								if(option.value !== "SUBSCRIPTION") {
									form.handleChange("subtype")("");
								}
								form.handleChange("type")(option.value);
								form.setFieldValue("licensing_enabled", false);
								form.setFieldValue("removeDuplicates", false);
							}}
							components={{
								SingleValue,
								Option
							}}
						/>
					</div>
				</>
				:
				<>
					<div className={`${form.errors.type && form.touched.type ? 'error' : ''} new-type-widget`} style={form.values.type ? {} : { borderBottom: "none", paddingBottom: 0, marginBottom: "1rem" }}>

						{(isVariant ? config.TYPE_OPTIONS_VARIANT : config.TYPE_OPTIONS).map(({ value, label }) => {

							const Icon = icons[value];
							return <div
								key={value}
								onClick={() => {
									if(value !== "SUBSCRIPTION") {
										form.handleChange("subtype")("");
									}
									form.handleChange("type")(value);
									form.setFieldValue("licensing_enabled", false);
									form.setFieldValue("removeDuplicates", false);
								}}
								className={`${(form.values.type === value) ? "active" : ""}`}
							>
								<div className={`new-type-widget-info ${(form.values.type === value) ? "active" : ""}`}>
									<div>{label}</div>
									<span>{description[value]}</span>
								</div>
								<div className={`new-type-widget-icon ${(form.values.type === value) ? "active" : ""}`}>
									<Icon className={(form.values.type === value) ? "active" : ""} />
								</div>
							</div>
						})}

						{form.errors.type && form.touched.type && <span className="type-widget-error">Type is required</span>}
					</div>
				</>
			}

		</div>

		{isSubscription && <div className="w-100 wm-100">

			<div className="d-flex justify-content-between flex-wrap">

				<SimpleSelect wrapperClassName="w-50 wm-100 pr-3" label="Recurring Interval" options={config.RECURRING_INTERVAL} name="recurring_interval" {...form} />

				<Text
					wrapperClassName="w-50 wm-100"
					label="Recurring Interval Count"
					type="number"
					name="recurring_interval_count"
					min={-1}
					{...form}
				/>

				<Text
					wrapperClassName="w-100 wm-100"
					label={<span className="text-nowrap">Trial Period <small>(<b>0</b> for no trial)</small></span>}
					type="number"
					name="trial_period"
					min={0}
					{...form}
				/>
			</div>

			<div className="paylixecommerce-note-big mt-0">
				Your customers will be billed every <b>{form.values.recurring_interval_count} {getDays()}</b>{form.values.trial_period ? ` after a trial of ${form.values.trial_period} days.` : `.`} Check out our <a href="https://developers.paylix.gg/#subscription" target="_blank">our documentation</a> for additional details.
			</div>

			<div className="mt-3 mb-3">
				<div className="mb-3">
					<div className="paylixecommerce-label" style={{ color: "var(--black9)" }}>Subscription Subtype</div>
				</div>

				{isMobile ?
					<div className="mb-3">
						<label className="paylixecommerce-label">Subscription type</label>
						<Select
							className={form.errors.type && form.touched.type ? 'error' : ''}
							size="large"
							value={form.values.subtype}
							onChange={e => form.handleChange("subtype")(e.target.value)}
							options={config.SUBTYPE_OPTIONS}
						/>
					</div>
					:
					<div className={`type-widget ${form.errors.type && form.touched.type ? 'error' : ''}`}>
						<div>
							{config.SUBTYPE_OPTIONS.map(({value, label}) => (
								<button
									key={value}
									type="button"
									className={(form.values.subtype === value || (form.values.subtype === null && value === "")) ? "active" : ""}
									onClick={() => form.handleChange("subtype")(value)}
								>
									{label}
								</button>
							))}
						</div>
					</div>
				}
				{form.errors.type && form.touched.type && <span className="type-widget-error">Subscription Type is required</span>}
			</div>

		</div>}

		{(form.values.type === "FILE" || form.values.subtype === "FILE") && <>

			<div className="mb-3">
				<MultipleUpload isBusiness={isBusiness} remove={removeFile} isMulti name="file" {...form} type="file" label="" />
			</div>

			<div className="d-flex flex-wrap">
				<Switch left label="Set how many times this file can be sold" wrapperClassName="mb-3" note={<>Leave <b>-1</b> for unlimited times</>} name="showStock" {...form} />
				{form.values.showStock && <Text wrapperClassName="w-100" label="" type="number" name="stock" min={-1} {...form} />}

				<MinMax form={form} isSubscription={isSubscription} />
			</div>
		</>}

		{(form.values.type === "SERIALS" || form.values.subtype === "SERIALS") && <div className="d-flex flex-wrap">

			<div className={delimiter === "custom" ? "w-50 wm-100 pr-3" : "w-100"}>
				<div className="">
					<label className="paylixecommerce-label">Stock Delimiter</label>

					<select
						className="paylixecommerce-select mb-4"
						value={delimiter}
						onChange={(e) => {
							setDelimiter(e.target.value);

							if(e.target.value !== "custom") {
								form.handleChange("stock_delimiter")(e.target.value)
							} else {
								form.handleChange("stock_delimiter")("")
							}
						}}>
						{config.DELIMITER_OPTIONS.map(({ value, label }) => <option key={value} value={value}>{label}</option>)}
					</select>

				</div>
			</div>

			{delimiter === "custom" && <Text wrapperClassName={delimiter === "custom" ? "w-50 wm-100 pr-3 mb-4" : "w-100 mb-4"} label="Custom Stock Delimiter" name="stock_delimiter" {...form} />}

			{isVariant ? null : <div className="w-100">
				<TextArea name="serials" label="Serials List" placeholder="SERIAL-KEY-1, SERIAL-KEY-2, SERIAL-KEY-3, SERIAL-KEY-4, ..." rows={3} {...form} />

				{licenseEnabled ? <GenerateSerials setDelimiter={setDelimiter} form={form} /> : null}
			</div>}


			{licenseEnabled ? null : <MinMax form={form} isSubscription={isSubscription} />}

			{licenseEnabled ? null : <div className="w-100">
				<div className="d-flex">
					<Text label="Label Singular" name="label_singular" placeholder="Ticket" {...form} wrapperClassName="w-50 pr-3" />
					<Text label="Label Plural" name="label_plural" placeholder="Tickets" {...form} wrapperClassName="w-50" />
				</div>
				<div className="paylixecommerce-note" style={{ marginTop: "-.75rem", marginBottom: "1.25rem" }}>
					This name will be used to refer to the product when shipped to the customer and in other cases, for example, if you're selling tickets you can set this to "Ticket" and on the delivery page we will say "Ticket purchased".
				</div>
			</div>}

			{/*{licenseEnabled ?*/}
			{false ?
				<Alert className="w-100" text={<>
					For products flagged as licenses, to keep an always unique <b>license_key</b> for your customers we will force the removal of duplicate serials (license keys) from the ones you upload and save.
				</>} title="Duplicates on Licensing" />
			: null}


			{form.values.type === "SERIALS" ?

				<Switch
					left
					label="Licensing"
					name="licensing_enabled"
					wrapperClassName="mb-4 mt-1"
					onChange={() => {
						form.setFieldValue("removeDuplicates", true);
					}}
					note="If enabled, each serial purchased by your customers will be treated as a license. This means that they will be able to purchase only one serial at a time and renew them after the period you have configured expired.
			You will also have access to a set of API endpoints you can use for your software to check whether or not a license is valid, expired, and associated with which hardware id."
					{...form}
				/>

				: null}

			{form.values.type === "SERIALS" && !isVariant && licenseEnabled &&
				<div className="w-100 mb-2">

					<div className="position-relative">
						<Text
							className="license-input"
							name="license_period"
							label="License Expiration"
							noteUnder
							note="Choose how much time every license you sell will last. Your customers will be prompted to renew their license a few days before expiration."
							{...form}
							onChange={(e) => {
								let value = +e.target.value
								form.setFieldValue("license_period", value.toFixed(0))
							}}
						/>
						<div className="license-input-details" style={{
							borderLeft: form.errors["license_period"] && form.touched["license_period"] ? "1px solid var(--red6)" : "1px solid var(--black0)",
						}}>
							Days
						</div>
					</div>

					{id ? <Alert
						className="mt-3"
						title="Editing license period"
						text="When you edit the license period, this will affect every ongoing license. Renewals will be using this period and it will be updated everywhere in your dashboard."
						red
					/> : null}
				</div>
			}


			<Switch left label="Remove Duplicate Serials" name="removeDuplicates" wrapperClassName="mb-3"
					note={<span>Is not a product-linked feature: it will not be saved with the product details. <br/> You can tick this option when you save and update your serials in order to remove any duplicate lines there might be.</span>}
					{...form}
			/>


			{isSubscription ?
				<div className="paylixecommerce-note-big w-100 mt-0 mb-4">
					Only one product <b>(quantity: 1)</b> can be purchased through subscriptions. Additionally, an unlimited stock policy is applied: Service, Files and Dynamic products will not have restrictions in terms of amounts that can be sold.
					Serials as well, with the only exception that the customer will be notified if the product is out of stock and asked to get in touch with the merchant; the payment is processed in any case.
				</div> : null
			}

			{licenseEnabled ? <div className="settings-how-block">
				<div className="settings-how-block-title" onClick={() => isMobile ? setHelp(!isHelpOpen) : null}>
					How it works
					{isMobile ? <div style={isHelpOpen ? { transform: "rotate(180deg)" } : {}}><CollapseArrow /></div> : null}
				</div>

				<Collapse isOpen={isMobile ? isHelpOpen : true}>
					<div className="settings-how three">
						<div>
							<div>
								<StandardIcon1 />
							</div>
							Customer buys your product just like they normally would
						</div>
						<div>
							<div>
								<StandardIcon2 />
							</div>
							A new license entry is created in your dashboard, to track active and expired licenses
						</div>
						<div>
							<div>
								<StandardIcon3 />
							</div>
							You can use our API to match every license code to a hardware id through our API
						</div>
					</div>
				</Collapse>
			</div> : null}

		</div>}

		{(form.values.type === "SERVICE" || form.values.subtype === "SERVICE") && <>
			<TextArea name="service_text" label="Service Info" {...form} placeholder="Our team will contact you within the next hours regarding your purchased service." />
			<div className="d-flex flex-wrap">
				<Switch left label="Set how many times this service can be sold" wrapperClassName="mb-3" note={<>Leave <b>-1</b> for unlimited times</>} name="showStock" {...form} />
				{form.values.showStock && <Text wrapperClassName="w-100" label="" type="number" name="stock" min={-1} {...form} />}

				<MinMax form={form} isSubscription={isSubscription} />
			</div>
		</>}

		{(form.values.type === "DYNAMIC" || form.values.subtype === "DYNAMIC") && <>
			<div className="w-100 wm-100 ">
				<Text label="Dynamic Webhook URL" name="dynamic_webhook" placeholder="Webhook URL" {...form} />
			</div>
			<div className="d-flex flex-wrap">
				<Switch left label="Set how many times this item can be sold" wrapperClassName="mb-3" note={<>Leave <b>-1</b> for unlimited times</>} name="showStock" {...form} />

				{form.values.showStock && <Text wrapperClassName="w-100" label="" type="number" name="stock" min={-1} {...form} />}

				<MinMax form={form} isSubscription={isSubscription} />
			</div>

			<div className="paylixecommerce-note-big mt-0">
				Check out our <a href="https://developers.paylix.gg/#dynamic" target="_blank" className="mx-1">documentation</a> for additional details.
			</div>
		</>}

	</div>
}